import { useEffect, useRef, useState, memo } from 'react';
// import { LottiePlayer } from 'lottie-web';

const LottieAnimation = ({ path, width = "100%", height = "100%" }) => {
  const ref = useRef(null);
  const [lottie, setLottie] = useState(null);

  useEffect(() => {
    import('lottie-web/build/player/lottie_light.min.js').then((Lottie) => setLottie(Lottie.default));
  }, []);

  useEffect(() => {
    if (lottie && ref.current) {
      const animation = lottie.loadAnimation({
        container: ref.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        // path to your animation file, place it inside public folder
        path,
      });

      return () => animation.destroy();
    }
  }, [lottie, path]);

  return (
    <div style={{ width, height }} ref={ref} />
  );
};

export default memo(LottieAnimation)